/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/jsx-props-no-spreading */

import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import * as Sentry from "@sentry/react";
import useUserConfig from "../../../hooks/useUserConfig";

import Styles from "../UserRoleManagement/style";
import EmptyFileIcon from "../../../assets/svg/EmptyFile";
import Loader from "../../../components/common/Loader/Loader";
import Modal from "../../../components/common/Modal/Modal";
import User from "../../../services/api/user";
import ManageIpConfigTable from "./IpConfigTable";
import PermissionModal from "../../../components/common/new/Modals/UserPermissionModals/PermissionModal";

function IpConfigManagement({ values }) {
  const [searchData, setSearchData] = useState([]);
  const [allData, setAllData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [selectedRole, setSelectedRole] = useState(null);
  const [newIp, setNewIp] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [venues, setVenues] = useState([]);
  const [selectedVenue, setSelectedVenue] = useState(null);

  // Add Venue form states
  const [newVenueName, setNewVenueName] = useState("");
  const [newVenueLocation, setNewVenueLocation] = useState("");
  const [newVenueActive, setNewVenueActive] = useState(true);

  const hasPermission = useUserConfig();

  // Fetch IP list
  const fetchIpConfigList = async () => {
    try {
      setIsLoading(true);
      const result = await User.getAllConfigIp();
      setSearchData(result.data);
      setAllData(result.data);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      Sentry.captureException(error);
    }
  };

  // Fetch Active Venues
  const fetchActiveVenues = async () => {
    try {
      const result = await User.getActiveVenues();
      setVenues(result.data);
    } catch (error) {
      Sentry.captureException(error);
    }
  };

  useEffect(() => {
    fetchActiveVenues();
    fetchIpConfigList();
  }, []);

  // Toggle IP status
  const handleToggleStatus = async (id, currentStatus) => {
    try {
      setIsLoading(true);
      await User.handleToggleStatus({ id, isActive: !currentStatus });
      fetchIpConfigList();
    } catch (error) {
      Sentry.captureException(error);
    } finally {
      setIsLoading(false);
    }
  };

  // Add IP
  const handleAddIp = async () => {
    if (!newIp) {
      alert("Please enter IP address");
      return;
    }

    try {
      setIsLoading(true);
      const result = await User.addMemberIp({
        ipAddress: newIp,
        venueId: selectedVenue?.id || null,
      });
      if (result?.code === 201 && !result?.error) {
        await fetchIpConfigList();
      }
      setNewIp("");
      setSelectedVenue(null);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      Sentry.captureException(error);
    }
  };

  // Update IP
  const handleUpdateIp = async (id, updatedIp) => {
    try {
      setIsLoading(true);

      // ✅ Optimistic update (UI me instant change dikhega)
      setSearchData((prev) =>
        prev.map((item) =>
          item.id === id ? { ...item, ipAddress: updatedIp } : item
        )
      );

      const payload = {};
      if (updatedIp) payload.ipAddress = updatedIp;
      await User.updateMemberIp(id, payload);

      // ✅ Server se fresh list bhi fetch kar le (consistency ke liye)
      fetchIpConfigList();
    } catch (error) {
      Sentry.captureException(error);
    } finally {
      setIsLoading(false);
    }
  };

  // Add Venue
  const handleAddVenue = async () => {
    if (!newVenueName || !newVenueLocation) {
      alert("Please enter venue name and location");
      return;
    }

    try {
      setIsLoading(true);
      const result = await User.addVenue({
        venueName: newVenueName,
        location: newVenueLocation,
        isActive: newVenueActive,
      });

      if (result?.code === 201 && !result?.error) {
        await fetchActiveVenues(); // refresh venue list
        setNewVenueName("");
        setNewVenueLocation("");
        setNewVenueActive(true);
      }

      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      Sentry.captureException(error);
    }
  };

  // Search
  const normalize = (str) => str.replace(/[^a-zA-Z0-9]/g, "").toLowerCase();
  const doSearch = (term) => {
    const search = normalize(term);
    if (!search) {
      setSearchData(allData);
      return;
    }
    const filtered = allData.filter((item) =>
      normalize(item.ipAddress).includes(search)
    );
    setSearchData(filtered);
  };
  const handleInputChange = (term) => {
    setSearchTerm(term);
    doSearch(term);
  };
  const handleSearchClick = () => doSearch(searchTerm);

  const onView = (row) => {
    setSelectedRole(row);
    setOpenModal(true);
  };
  const closeModal = () => setOpenModal(false);

  return (
    <div style={Styles.container}>
      {/* Search Bar */}
      <div style={{ marginBottom: "16px", display: "flex", gap: "8px" }}>
        <input
          type="text"
          placeholder="Search by IP address"
          value={searchTerm}
          onChange={(e) => handleInputChange(e.target.value)}
          style={{ padding: "8px", flex: 1 }}
        />
        <button
          type="button"
          onClick={handleSearchClick}
          style={{
            backgroundColor: "#043D90",
            color: "#fff",
            border: "none",
            borderRadius: "6px",
            padding: "8px 16px",
            cursor: "pointer",
          }}
        >
          Search
        </button>
      </div>

      {/* Add IP Form */}
      <div style={{ marginBottom: "16px", display: "flex", gap: "8px" }}>
        <input
          type="text"
          placeholder="Enter IP Address"
          value={newIp}
          onChange={(e) => setNewIp(e.target.value)}
          style={{ padding: "8px", flex: 1 }}
        />
        <select
          value={selectedVenue?.id || ""}
          onChange={(e) =>
            setSelectedVenue(
              venues.find((v) => v.id === Number(e.target.value))
            )
          }
          style={{ padding: "8px" }}
        >
          <option value="">Select Venue</option>
          {venues.map((v) => (
            <option key={v.id} value={v.id}>
              {v.venueName}
            </option>
          ))}
        </select>
        <button
          type="button"
          onClick={handleAddIp}
          style={{
            backgroundColor: "#388f38ff",
            color: "#fff",
            border: "none",
            borderRadius: "6px",
            padding: "8px 16px",
            cursor: "pointer",
          }}
        >
          Add IP
        </button>
      </div>

      {/* Add Venue Form */}
      <div
        style={{
          marginBottom: "16px",
          display: "flex",
          gap: "8px",
          alignItems: "center",
        }}
      >
        <input
          type="text"
          placeholder="Venue Name"
          value={newVenueName}
          onChange={(e) => setNewVenueName(e.target.value)}
          style={{ padding: "8px", flex: 2 }}
        />
        <input
          type="text"
          placeholder="Location"
          value={newVenueLocation}
          onChange={(e) => setNewVenueLocation(e.target.value)}
          style={{ padding: "8px", flex: 3 }}
        />
        <select
          value={newVenueActive}
          onChange={(e) => setNewVenueActive(e.target.value === "true")}
          style={{ padding: "8px" }}
        >
          <option value="true">Active</option>
          <option value="false">Inactive</option>
        </select>
        <button
          type="button"
          onClick={handleAddVenue}
          style={{
            backgroundColor: "#043D90",
            color: "#fff",
            border: "none",
            borderRadius: "6px",
            padding: "8px 16px",
            cursor: "pointer",
          }}
        >
          Add Venue
        </button>
      </div>

      {/* Table or No Data */}
      <div style={Styles.main}>
        {searchData?.length ? (
          <ManageIpConfigTable
            searchData={searchData}
            onToggleStatus={handleToggleStatus}
            onUpdateIp={handleUpdateIp}
            onView={onView}
            hasPermission={hasPermission}
          />
        ) : (
          <div style={Styles.initialContent}>
            <EmptyFileIcon width={100} />
            <span style={Styles.text}>No data found</span>
          </div>
        )}
      </div>

      {isLoading && <Loader />}

      {/* Modal */}
      <Modal open={openModal} onClose={closeModal} title="Permission">
        <PermissionModal
          open={openModal}
          roles={selectedRole}
          onClose={closeModal}
          values={values}
        />
      </Modal>
    </div>
  );
}

IpConfigManagement.propTypes = {
  values: PropTypes.shape({}),
};

IpConfigManagement.defaultProps = {
  values: {},
};

export default IpConfigManagement;
